import { Component, inject } from '@angular/core';
import { BrandService } from '@app/shared/services/brand/brand.service'; // Verifica tu ruta exacta
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
})
export class LoaderComponent {
  public brandService = inject(BrandService);
}
